'use strict';

function WealthArticleGallery() {
  this.id = null;
  this.node = null;
  this.extends = [_WealthController, ArticleGallery];

  this.contentId = ''; // 'wealth' (defined in pug file)

  this.init = function () {
    this._super();

    this.initPage();
  };

  this.initPage = function () {
    this.initArticleGallery();
  };

  this.initAllReady = function () {};

  this.destroy = function () {
    this.destroyArticleGallery();
  };
}